import http, { Http } from '@/lib/http';

function addPricingAgreementCtor(http: Http) {
  return async (projectId: string) => {
    await http.post(`/projects/${projectId}/pricing`);
  };
}

export const addPricingAgreement = addPricingAgreementCtor(http);
